import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import { useCurrentWidth } from 'react-socks';
import "./navbar.css";

function NavBar(props) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const width = useCurrentWidth();

  return (
    <nav className="navbar-container">
      <div className="logo">
        <h4>F A R U Q</h4>
      </div>
      <div className={`menu-icon ${isMenuOpen ? 'open' : ''}`} onClick={toggleMenu}>
        <div className="menu-line"></div>
        <div className="menu-line"></div>
        <div className="menu-line"></div>
      </div>
      <ul className={`navbar-list ${isMenuOpen ? 'active' : ''}`}>
        <li className="navbar-item"><NavLink exact to="/" activeClassName="active" onClick={toggleMenu}>Home</NavLink></li>
        <li className="navbar-item"><a href="./#about" onClick={toggleMenu}>About</a></li>
        <li className="navbar-item"><a href="./#portfolio" onClick={toggleMenu}>Portfolio</a></li>
        <li className="navbar-item"><a href="./#contact" onClick={toggleMenu}>Contact</a></li>
        <li className="navbar-item"><NavLink to="/data-scraping" activeClassName="active" onClick={toggleMenu}>Data Scraping I</NavLink></li>
        {
          width <= 899 && <li className="navbar-item"><NavLink to="https://drive.usercontent.google.com/download?id=1hQBXO9Uzqvc5tXUeBCSKC5uLakCLbm7p&export=download&authuser=0&confirm=t&uuid=9daf7eee-a501-4426-ac12-f5c0c86911d5&at=APZUnTUsYpqa3EVqmqqtpe1owm3S:1709004559349" activeClassName="active" onClick={toggleMenu}>Download CV</NavLink></li>
        }
      </ul>
      <div className="cv">
        <a className="btn-secondary" href="https://drive.usercontent.google.com/download?id=1hQBXO9Uzqvc5tXUeBCSKC5uLakCLbm7p&export=download&authuser=0&confirm=t&uuid=9daf7eee-a501-4426-ac12-f5c0c86911d5&at=APZUnTUsYpqa3EVqmqqtpe1owm3S:1709004559349">Download CV</a>
      </div>
    </nav>
  );
}

export default NavBar;
